import { Component, OnInit, Input, OnDestroy, Output, EventEmitter } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AppletContainerModel, bl_applet_ext_RowClass } from 'blg-akaun-ts-lib';
import { Observable } from 'rxjs';
import { SubSink } from 'subsink2';
import { AppConfig } from '../../../visa';
import { DeleteRendererComponent } from './delete-renderer/delete-renderer.component';
@Component({
  selector: 'app-webhook',
  templateUrl: './webhook.component.html',
  styleUrls: ['./webhook.component.css']
})
export class WebhookComponent implements OnInit, OnDestroy {

  @Input() appletSettings$: Observable<AppletContainerModel>;

  @Output() save = new EventEmitter<AppletContainerModel>();

  private subs = new SubSink();

  apiVisa = AppConfig.apiVisa;

  branch = new FormControl();
  location = new FormControl();

  appletContainer: AppletContainerModel;

  defaultColDef = {
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {suppressFilterButton: true},
    flex: 3,
    sortable: true,
    resizable: true,
    editable: true,
    autoHeight: true,
    suppressCsvExport: true
  };

  columnDefs = [
    { field: 'Name' },
    {
      field: 'Event Queue' ,
      floatingFilter: false,
      editable: false,
      cellRenderer: 'agGroupCellRenderer'
    },
    {
      field: 'Parameters' ,
      floatingFilter: false,
      editable: false,
      cellRenderer: 'agGroupCellRenderer'
    },
    {
      field: 'Status',
      cellEditor: 'agSelectCellEditor',
      cellEditorParams: {
        values: ['ACTIVE', 'INACTIVE'],
      },
    },
    {
      field: String.fromCodePoint(0x1F6AE),
      floatingFilter: false,
      // flex: 1,
      sortable: false,
      resizable: false,
      editable: false,
      cellRenderer: 'deleteCellRenderer'
    }
  ];

  columnParamDefs = [
    { field: 'Param Name' },
    { field: 'Param Value' },
    {
      field: String.fromCodePoint(0x1F6AE),
      floatingFilter: false,
      flex: 1,
      sortable: false,
      resizable: false,
      editable: false,
      cellRenderer: 'deleteCellRenderer'
    }
  ];

  rowData = [
    {Name: 'Trigger #1', 'Event Queue': [], Status: 'ACTIVE'},
    {Name: 'Trigger #2', 'Event Queue': [], Status: 'ACTIVE'},
    {Name: 'Trigger #3', 'Event Queue': [], Status: 'ACTIVE'}
  ]

  paramRowData = []

  form: FormGroup;

  topic = new FormControl('', Validators.required);

  frameworkComponents = {
    deleteCellRenderer: DeleteRendererComponent,
  };

  detailCellRendererParams;

  hardCodedEvents = [
    'Sample Event #1',
    'Sample Event #2',
    'Sample Event #3',
    'Sample Event #4',
    'Sample Event #5',
    'Sample Event #6',
    'Sample Event #7',
    'Sample Event #8',
    'Sample Event #9',
    'Sample Event #10',
  ]

  constructor() {
    this.detailCellRendererParams = {
      detailGridOptions: {
        columnDefs: [
          {
            field: 'Event Code',
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: {
              values: this.hardCodedEvents
            },
          },
          { field: 'Event Name', editable: false},
          { field: 'Event Description' }
        ],
        defaultColDef: {
          filter: 'agTextColumnFilter',
          floatingFilter: true,
          floatingFilterComponentParams: {suppressFilterButton: true},
          flex: 1,
          sortable: true,
          resizable: true,
          editable: true
        },
        rowData: [
          {'Event Code': 'Sample Event #1', 'Event Name': 'Sample Event #1', 'Event Description': 'Some Description'},
          {'Event Code': 'Sample Event #2', 'Event Name': 'Sample Event #2', 'Event Description': 'Some Description'},
          {'Event Code': 'Sample Event #3', 'Event Name': 'Sample Event #3', 'Event Description': 'Some Description'},
        ],
        // domLayout: 'autoHeight',
        singleClickEdit: 'true'
      }
    };
  }

  ngOnInit() {
    this.form = new FormGroup({
      name: new FormControl('', Validators.required),
      status: new FormControl('ACTIVE', Validators.required)
    })
    this.subs.sink = this.branch.valueChanges.subscribe({next: resolve => {
      const exist = this.appletContainer.bl_applet_exts.find(x => x.param_code === 'APPLET_SETTINGS');
      if (exist) {
        this.appletContainer.bl_applet_exts.find(x => x.param_code === 'APPLET_SETTINGS').value_json = {
          ...this.appletContainer.bl_applet_exts.find(x => x.param_code === 'APPLET_SETTINGS').value_json,
          DEFAULT_BRANCH: resolve
        };
      } else {
        const appletExt = new bl_applet_ext_RowClass();
        appletExt.param_code = 'APPLET_SETTINGS';
        appletExt.param_name = 'APPLET_SETTINGS';
        appletExt.param_type = 'JSON';
        appletExt.value_json = {
          DEFAULT_BRANCH: resolve
        };
        this.appletContainer.bl_applet_exts.push(appletExt);
      }
    }});
    this.subs.sink = this.location.valueChanges.subscribe({next: resolve => {
      const exist = this.appletContainer.bl_applet_exts.find(x => x.param_code === 'APPLET_SETTINGS');
      if (exist) {
        this.appletContainer.bl_applet_exts.find(x => x.param_code === 'APPLET_SETTINGS').value_json = {
          ...this.appletContainer.bl_applet_exts.find(x => x.param_code === 'APPLET_SETTINGS').value_json,
          DEFAULT_LOCATION: resolve
        };
      } else {
        const appletExt = new bl_applet_ext_RowClass();
        appletExt.param_code = 'APPLET_SETTINGS';
        appletExt.param_name = 'APPLET_SETTINGS';
        appletExt.param_type = 'JSON';
        appletExt.value_json = {
          DEFAULT_LOCATION: resolve
        };
        this.appletContainer.bl_applet_exts.push(appletExt);
      }
    }});
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

}
